<template>
  <button
    class="btn place-order-btn btn-primary"
    v-bind:class="checkoutValidation.success || isInvalidTimeslot ? '' : 'disabled'"
    @click="openProceedConfirmation"
  >
    Start checkout
  </button>
</template>

<script>

import { checkout as checkoutMixin } from '../mixins/checkout'

export default {
  name: 'CheckoutNowButton',
  mixins: [
    checkoutMixin
  ],
  methods: {
    openProceedConfirmation: function () {
      // If we ever need to prompt the user with a confirmation message before
      // going to checkout, check for the message here
      //ex. const hasConfirmationBCCMessage = !!_.get(window, "heb.data.message.limitedAddonsPerOrderAlert.body", false);

      const hasConfirmationBCCMessage = false;

      if (hasConfirmationBCCMessage) {
        this.$bvModal.show('proceed-to-checkout-modal');
      } else {
        this.proceedToCheckout();
      }
    }
  }
}
</script>
